import { useAppSelector } from '@/store/hooks';
import { selectProjectThemePack } from '@/store/slices/project/selectors';

const useGetWorkingProjectThemePack = () => {
  const projectThemePack = useAppSelector(selectProjectThemePack);
  return projectThemePack;
};

export default useGetWorkingProjectThemePack;
